import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, Users, HelpCircle, LogOut, FileText, User } from 'lucide-react';

// Header Component
const Header = ({ userId, userGroup, onLogout }) => {
  const [showLogoutMenu, setShowLogoutMenu] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    setShowLogoutMenu(false);
    onLogout();
  };

  const handleShowProfile = () => {
    navigate('/profile');
    setShowLogoutMenu(false);
  };

  return (
    <header className="bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
      <div className="flex items-center gap-8">
        
        <span className="text-sm text-gray-600">Login as {userId} ({userGroup})</span>
      </div>
      <div className="relative">
        <button 
          onClick={() => setShowLogoutMenu(!showLogoutMenu)}
          className="p-2 hover:bg-gray-100 rounded-full"
        >
          <User className="w-5 h-5 text-gray-600" />
        </button>
        
        {showLogoutMenu && (
          <>
            <div 
              className="fixed inset-0 z-10" 
              onClick={() => setShowLogoutMenu(false)}
            ></div>
            <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-20">
              <button
                onClick={handleShowProfile}
                className="w-full flex items-center gap-3 px-4 py-3 hover:bg-gray-50 text-left text-gray-700"
              >
                <User className="w-5 h-5" />
                <span className="text-sm font-medium">My Profile</span>
              </button>
              <button
                onClick={handleLogout}
                className="w-full flex items-center gap-3 px-4 py-3 hover:bg-gray-50 text-left text-gray-700"
              >
                <LogOut className="w-5 h-5" />
                <span className="text-sm font-medium">Log Out</span>
              </button>
            </div>
          </>
        )}
      </div>
    </header>
  );
};

export default Header